export function validateVIN(vin, options = {}) {
    if (!vin) return false;
    
    // Normalize to uppercase
    const normalizedVin = vin.toUpperCase().trim();
    
    if (options.isPre1969 || options.isPre1981) {
        // Legacy serial numbers can be almost anything, just check length
        return normalizedVin.length >= 4 && normalizedVin.length <= 20;
    }

    // Basic alphanumeric check, strictly excluding I, O, Q
    const isValidChars = /^[A-HJ-NPR-Z0-9]+$/.test(normalizedVin);
    if (!isValidChars) return false;

    // Standard VINs (1981 and newer) must be exactly 17 characters.
    return normalizedVin.length === 17;
}
